import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthActions } from '@auth/store';
import { DispositifActions } from '@features/referentiel/actions/dispositif.actions';
import { DispositifService } from '@features/referentiel/services/dispositif.service';



@Injectable()
export class DispositifEffects {

    initDispositifs$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.userProfileLoaded),
            map(() => DispositifActions.getDispositif())
        )
    );

    loadDispositifs$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DispositifActions.getDispositif),
            switchMap(() =>
                this.dispositifService.getDispositifs().pipe(
                  map((data) => DispositifActions.getDispositifSuccess({ dispositifs: data.response })),
                  catchError((error) => of(DispositifActions.getDispositifFailure({ errorMessage: error })))
                )
            )
        )
    );

    constructor(private actions$: Actions, private dispositifService: DispositifService) { }
}
